<template>
  <div class="tw-w-screen lg:tw-py-12 md:tw-py-6">
    <div
      class="tab-view-container tw-w-full tw-flex tw-flex-col"
      :class="{ 'animate-slide-up': isVisible }"
    >
      <span
        class="tw-w-full tw-text-center tw-text-4xl tw-font-bold tw-text-textMain tw-mb-10"
        v-html="$t('首页小标题')"
      ></span>

      <div class="home-section-inner">
          <div class="tw-flex tw-flex-col tw-w-full">
            <div class="tw-flex tw-w-full tw-justify-center">
              <!-- Tab 背景容器 -->
              <ul 
                class="tw-list-none tw-flex tw-mb-10 tw-items-center tw-justify-center"
                style="
                  height: 48px;
                  background: #F4F4F4;
                  border-radius: 100px;
                  padding: 4px;
                "
              >
                <li
                  v-for="item in tabsList"
                  :key="item.categoryId"
                  class="tw-flex tw-items-center tw-justify-center tw-cursor-pointer tw-transition-all"
                  @click="handleTabClick(item)"
                >
                  <div
                    class="tw-flex tw-items-center tw-justify-center tw-py-2 tw-px-6 tw-transition-all"
                    :class="{
                      'tab-item-active': item.categoryId == activeTabId,
                    }"
                    :style="{
                      height: item.categoryId == activeTabId ? '40px' : 'auto',
                      padding: item.categoryId == activeTabId ? '0 20px' : '0 20px',
                      background: item.categoryId == activeTabId ? '#FFFFFF' : 'transparent',
                      borderRadius: '100px',
                      fontWeight: 600,
                      fontSize: '16px',
                      color: item.categoryId == activeTabId ? '#111111' : '#666666'
                    }"
                  >
                    <span>{{ displayCategoryName(item) }}</span>
                  </div>
                </li>
              </ul>
            </div>
           <!-- 卡片轮播布局 -->
            <div class="tw-relative">
              <!-- 左箭头 -->
              <div
                class="swiper-prev tw-absolute tw-left-0 tw-top-1/2 tw--translate-y-1/2 tw-z-10 tw-cursor-pointer tw-w-10 tw-h-10 tw-flex tw-items-center tw-justify-center tw-bg-white tw-rounded-full tw-shadow-md hover:tw-shadow-lg tw-transition-all"
                style="transform: translate(-140%, -50%)"
              >
                <b-icon icon="chevron-left" class="tw-text-textMain"></b-icon>
              </div>

              <!-- Swiper 轮播 -->
              <swiper
                ref="productSwiper"
                :options="productSwiperOption"
                class="product-swiper"
              >
                <swiper-slide
                  v-for="(item, index) in swiperList"
                  :key="item.id || index"
                  class="tw-flex tw-justify-center"
                >
                  <div
                    class="product-card tw-cursor-pointer tw-transition-all hover:tw-shadow-lg"
                  >
                    <!-- 背景 -->
                    <div 
                      class="tw-w-full tw-h-full tw-flex tw-flex-col tw-justify-between"
                      @click="handleCardClick(item)"
                    >
                      <img
                        :src="item.pic"
                        alt=""
                        class="tw-w-full tw-h-full tw-object-cover"
                        style="position: absolute; top: 0; left: 0; z-index: 0;"
                      />
                      
                      <!-- 文字内容 -->
                      <div 
                        class="tw-relative tw-z-10 tw-flex tw-flex-col tw-justify-start tw-h-full" 
                        style="padding: 40px;"
                      >
                        <h3
                          class="tw-text-left tw-mb-0"
                          style="
                            font-weight: 600;
                            color: #111111;
                          "
                          :style="{
                            fontSize: $screen.xl ? '24px' : ($screen.lg ? '20px' : '18px')
                          }"
                        >
                          {{ item.name }}
                        </h3>
                        <p
                          class="tw-text-left tw-mt-3"
                          style="
                            font-weight: 400;
                            color: #666666;
                          "
                          :style="{
                            fontSize: $screen.xl ? '14px' : '12px',
                            lineHeight: $screen.xl ? '20px' : '18px'
                          }"
                        >
                          {{ item.intro }}
                        </p>
                      </div>
                    </div>
                  </div>
                </swiper-slide>
              </swiper>

              <!-- 右箭头 -->
              <div
                class="swiper-next tw-absolute tw-right-0 tw-top-1/2 tw--translate-y-1/2 tw-z-10 tw-cursor-pointer tw-w-10 tw-h-10 tw-flex tw-items-center tw-justify-center tw-bg-white tw-rounded-full tw-shadow-md hover:tw-shadow-lg tw-transition-all"
                style="transform: translate(140%, -50%)"
              >
                <b-icon icon="chevron-right" class="tw-text-textMain"></b-icon>
              </div>
            </div>
            <div class="tw-mt-10 tw-text-center">
              {{ $t("找不到合适的产品或方案？") }}
              <span
                style="color: #4077F8FF; cursor: pointer;"
                @click="handleConsultClick"
              >
                <span>{{ $t("查看更多") }}</span>
                <b-icon icon="chevron-right" class="tw-ml-1"></b-icon>
              </span>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import referrerImg from "@/assets/home/referrer-icon.png";
import { productsApi } from "@/api/modules/home";
import { getCategoryDisplayName } from "@/utils/category";
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
    data() {
    return {
      referrerImg,
      tabsList: [],
      isVisible: false,
      observer: null,
      activeTabId: 1,
      hoverId: -1,
      productSwiperOption: {
        slidesPerView: 4,
        spaceBetween: 40,
        loop: false,
        navigation: {
          nextEl: ".swiper-next",
          prevEl: ".swiper-prev",
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 35,
          },
          1280: {
            slidesPerView: 4,
            spaceBetween: 40,
          },
        },
      },
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 30,
        navigation: {
          nextEl: ".swiper-next",
          prevEl: ".swiper-prev",
        },
        centeredSlides: false,
      },
    };
  },
  computed: {
    swiperList() {
      if (!this.tabsList || this.tabsList.length <= 0) {
        return [];
      }

      let item = this.tabsList.find(
        (item) => item.categoryId == this.activeTabId,
      );

      // 增加安全检查
      if (!item || !item.products || !Array.isArray(item.products)) {
        return [];
      }

      if (item.products.length > 7) {
        return item.products.slice(0, 7);
      }
      return item.products;
    },
  },
  mounted() {
    const info = JSON.parse(localStorage.getItem("indexInfo"));
    if (info) {
      this.getList();
    }
    this.$nextTick(() => {
      setTimeout(() => {
        this.initIntersectionObserver();
      }, 500);
    });
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    displayCategoryName(category) {
      return this.translateText(
        getCategoryDisplayName(category, this.$i18n.locale),
      );
    },
    handleToMore() {
      this.$router.push({
        path: "/product",
      });
    },

    handleHover(hover, id) {
      this.hoverId = hover ? id : -1;
    },
    initIntersectionObserver() {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.isVisible) {
              this.isVisible = true;
              // 动画只执行一次，所以可以断开观察器
              this.observer.disconnect();
            }
          });
        },
        {
          threshold: 0.1, // 当组件10%可见时触发
          rootMargin: "0px 0px -50px 0px", // 提前50px触发
        },
      );

      this.observer.observe(this.$el);
    },
    getList() {
      let info = JSON.parse(localStorage.getItem("indexInfo"));
      this.tabsList = this.normalizeHomeProductTabs(
        info.recommendProductList.slice(0, 3),
      );

      // 添加"精选推荐"分类
      this.tabsList.unshift({
        categoryId: -1,
        categoryName: this.$t("精选推荐"),
        products: [], // 初始为空，稍后通过API获取
      });

      // 添加"公链生态"分类
      this.tabsList.push({
        categoryId: 69,
        categoryName: this.$t("公链生态"),
        products: [], // 初始为空，稍后通过API获取
      });

      if (this.tabsList.length > 0) {
        this.activeTabId = this.tabsList[0].categoryId;
        if (this.activeTabId === -1) {
          this.fetchRecommendProducts();
        }
      }
    },

    async fetchRecommendProducts() {
      try {
        const res = await productsApi({
          pageIndex: 1,
          pageSize: 7,
          isRecommend: 1,
        });

        if (res && res.data && res.data.list) {
          // 更新tabsList中categoryId为-1的项的products数据
          const recommendTab = this.tabsList.find(
            (item) => item.categoryId === -1,
          );
          if (recommendTab) {
            this.$set(recommendTab, "products", res.data.list.slice(0, 7));
          }
        }
      } catch (error) {
        console.error("获取推荐产品失败:", error);
      }
    },

    async fetchPublicChainProducts() {
      try {
        const res = await productsApi({
          pageIndex: 1,
          pageSize: 7,
          categoryId: 69,
          sortField: "id",
          sortOrder: "asc",
        });

        if (res && res.data && res.data.list) {
          const publicChainTab = this.tabsList.find(
            (item) => item.categoryId === 69,
          );
          if (publicChainTab) {
            this.$set(
              publicChainTab,
              "products",
              this.sortProductsById(res.data.list).slice(0, 7),
            );
          }
        }
      } catch (error) {
        console.error("获取公链生态产品失败:", error);
      }
    },
    sortProductsById(products = []) {
      if (!Array.isArray(products)) {
        return [];
      }
      // 首页产品模块要求老产品优先，统一按产品 ID 从小到大展示。
      return [...products].sort((a, b) => Number(a.id || 0) - Number(b.id || 0));
    },
    normalizeHomeProductTabs(tabs = []) {
      if (!Array.isArray(tabs)) {
        return [];
      }
      return tabs.map((item) => ({
        ...item,
        products: this.sortProductsById(item.products),
      }));
    },
    translateText(text) {
      if (!text) {
        return "";
      }
      return this.$te(text) ? this.$t(text) : text;
    },
    handleClickRoute(row) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      if (row.id) {
        localStorage.setItem("detailForm", JSON.stringify(row));
        this.$router.push({
          path: "/product/" + row.id + "?isApi=false",
        });
      } else {
        this.$router.push({
          path: "/product",
        });
      }
    },
    handleTabClick(item) {
      this.activeTabId = item.categoryId;
      // 如果点击的是推荐产品(-1)，并且还没有加载过数据，则请求数据
      if (
        item.categoryId === -1 &&
        (!item.products || item.products.length === 0)
      ) {
        this.fetchRecommendProducts();
      }
      // 如果点击的是公链生态(69)，并且还没有加载过数据，则请求数据
      if (
        item.categoryId === 69 &&
        (!item.products || item.products.length === 0)
      ) {
        this.fetchPublicChainProducts();
      }
    },
    handleCardClick(row) {
      console.log(11111, row);
      window.scrollTo({ top: 0, behavior: "smooth" });
      if (row.id) {
        localStorage.setItem("detailForm", JSON.stringify(row));
        this.$router.push({
          path: "/product/" + row.id + "?isApi=false",
        });
      } else {
        this.$router.push({
          path: "/product",
        });
      }
    },
    handleConsultClick() {
      window.scrollTo({ top: 0, behavior: "smooth" });
      // if (row.id) {
      //   localStorage.setItem("detailForm", JSON.stringify(row));
      //   this.$router.push({
      //     path: "/solution/" + row.id + "?isApi=false",
      //   });
      // } else {
        this.$router.push({
          path: "/product",
        });
      // }
    },
  },
};
</script>

<style scoped lang="scss">
.tab-view-container {
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s ease-out;
}

.tab-view-container.animate-slide-up {
  opacity: 1;
  transform: translateY(0);
}

.swiper {
  height: 440px;
  width: 100%;
  max-width: 1440px !important;
  .swiper-slide {
    display: flex;
  }
}

.swiper-box {
  background-color: #fff;
  box-shadow: 0px 0px 30px 0px rgba(48, 66, 137, 0.05);
  border-radius: 8px !important;
  padding: 55px !important;
  position: relative;

  &:hover {
    // 添加轻微阴影
    -webkit-box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.1);
  }
}


.swiper-but {
  color: #666;
  border-radius: 100px;
  &:hover {
    color: #fff;
    background: linear-gradient(90deg, #4077F8 0%, #3D4BDF 100%);
  }
}

.product-swiper {
  padding: 20px 0;
  
  .swiper-slide {
    height: auto;
  }
}

.product-card {
  width: 335px;
  height: 350px;
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  background: #ffffff;
  
  @media (max-width: 768px) {
    width: 100%;
    max-width: 335px;
  }
}

@media (max-width: 1200px) {
  .swiper-prev {
    transform: translate(-50%, -50%) !important;
  }

  .swiper-next {
    transform: translate(50%, -50%) !important;
  }
}

@media (max-width: 1024px) {
  .swiper-prev,
  .swiper-next {
    display: none !important;
  }

  .product-card {
    width: min(335px, 100%);
  }
}
</style>
